<template>
  <div class="page flex-col">
    <div class="top-bar flex-row">
      <img class="logo" referrerpolicy="no-referrer" src="./assets/img/SketchPng1b873447787c9cbb3e41368859a9d2c662c59bd8506395ceca20ebd4c958e4c0.png" />
      <span class="nav-link" @click="showContact = true">联系我们</span>
    </div>
    <div class="banner flex-col">
      <span class="banner-title">基于AI的建筑业数字化建造互联网平台</span>
    </div>
    <div class="main-area flex-row">
      <div class="sidebar flex-col">
        <div class="nav-item" @click="$router.push('/lanhu_quanguochengshuzihua')">全过程数字化管控</div>
        <div class="nav-item" @click="$router.push('/lanhu_zhengxiangshejijieduan')">正向设计阶段</div>
        <div class="nav-item active" @click="$router.push('/lanhu_heidengshengchanjieduan')">黑灯生产阶段</div>
        <div class="nav-item" @click="$router.push('/lanhu_wurenshigong')">无人/少人施工阶段</div>
        <div class="nav-item" @click="$router.push('/lanhu_zhihuiyunwei')">智慧运维阶段</div>
        <div class="nav-item" @click="$router.push('/lanhu_qita')">其他AI智能体</div>
        <div class="nav-item" @click="showContact = true">定制开发模块</div>
      </div>

      <div class="content-area flex-row justify-between">
        <!-- 管道下料模块 -->
        <div class="card-box flex-col">
          <span class="card-title">管道下料模块</span>
          <span class="card-sub">（可定制）</span>
          <img class="card-icon" referrerpolicy="no-referrer" src="./assets/img/SketchPng4384b4dc1fa111bf5fe48705cc550c751578814dc0f284c3acd207ee0b56fceb.png" />
          <span class="card-desc">面向管道加工、预制工厂、装配式管线生产场景，依托数字化算法、自动算料、排版优化、生产联动能力，实现管道智能计算、最优排料、自动出图、工单下发、生产追溯全流程数字化管控，支持按需功能定制、对接产线设备，适配多行业管道加工需求。</span>
          <div class="download-btn flex-col" @click="downloadFile('heideng_guandao_xialiao')"><span class="btn-text">下载</span></div>
        </div>
        <!-- 工厂对接模块 -->
        <div class="card-box flex-col">
          <span class="card-title">工厂对接模块</span>
          <span class="card-sub">（定制）</span>
          <img class="card-icon" referrerpolicy="no-referrer" src="./assets/img/SketchPng03a6166fb575a5eb67727aba1f05cfb9db36f9d3880553f47485eacf1a35b5fc.png" />
          <span class="card-desc">聚焦多工厂、多车间、上下游产业链的数据互通、业务联动与流程协同，打通各环节数据壁垒，实现全链路数字化流转。模块支持接口、流程、字段、权限、对接模式全定制，适配单厂集约化生产、多厂区分布式生产、跨企业外协代工等不同经营模式。</span>
          <div class="download-btn flex-col" @click="showContact = true"><span class="btn-text">联系我们</span></div>
        </div>
      </div>
    </div>

    <div class="footer flex-row">
      <img class="footer-logo" referrerpolicy="no-referrer" src="./assets/img/SketchPng23c7966a2d1963c6b88ae89421a6a417dd7b177ac534af52d26b60f665e3e49f.png" />
      <span class="footer-text">赢技科技发展（杭州）有限公司&nbsp;<br/>联系我们：yingji&#64;yjyunjz.com<br/>版权所有&nbsp;浙ICP备1214545号-1</span>
    </div>

    <div class="contact-modal-mask" v-if="showContact" @click.self="showContact = false">
      <div class="contact-modal">
        <div class="contact-modal-header"><span class="contact-modal-title">联系我们</span><span class="contact-modal-close" @click="showContact=false">✕</span></div>
        <div class="contact-modal-body">
          <div class="contact-item"><span class="contact-label">公司名称：</span><span class="contact-value">赢技科技发展（杭州）有限公司</span></div>
          <div class="contact-item"><span class="contact-label">联系邮箱：</span><a class="contact-value contact-link" href="mailto:yingji@yjyunjz.com">yingji@yjyunjz.com</a></div>
          <div class="contact-item"><span class="contact-label">官方网站：</span><span class="contact-value">www.yjyunjz.com</span></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showContact: false,
      downloadLinks: { heideng_guandao_xialiao: 'https://yj-builder.oss-cn-hangzhou.aliyuncs.com/YJZWeb/heideng_guandao_xialiao.rar', heideng_gongchang_duijie: '' }
    };
  },
  methods: { downloadFile(key) { const url = this.downloadLinks[key]; if (url) { const a=document.createElement('a'); a.href=url; a.download=key+'.zip'; document.body.appendChild(a); a.click(); document.body.removeChild(a);} } }
};
</script>
<style scoped lang="css" src="./assets/index.css" />
<style scoped>
.nav-link{cursor:pointer}.nav-link:hover{opacity:0.75}
.download-btn{cursor:pointer;transition:opacity .2s,transform .15s}.download-btn:hover{opacity:.85;transform:scale(1.03)}
.btn-disabled{cursor:not-allowed;opacity:.45;filter:grayscale(60%);pointer-events:none}
.contact-modal-mask{position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,.5);display:flex;align-items:center;justify-content:center;z-index:9999}
.contact-modal{background:#fff;border-radius:12px;padding:32px 40px;min-width:380px;box-shadow:0 16px 48px rgba(0,0,0,.2)}
.contact-modal-header{display:flex;align-items:center;justify-content:space-between;margin-bottom:24px}
.contact-modal-title{font-size:20px;font-weight:700;color:#1a1a2e}
.contact-modal-close{cursor:pointer;font-size:18px;color:#999;padding:4px}.contact-modal-close:hover{color:#333}
.contact-modal-body{display:flex;flex-direction:column;gap:16px}
.contact-item{display:flex;align-items:flex-start;font-size:15px;line-height:1.6}
.contact-label{color:#666;white-space:nowrap;min-width:90px}
.contact-value{color:#1a1a2e;font-weight:500}
.contact-link{color:#2563eb;text-decoration:none}.contact-link:hover{text-decoration:underline}
</style>
